import {TariffBase} from './tariff-base';

export const DeliveryType = 'Delivery';
export const SupplyType = 'Supply';
export interface TariffEntity extends TariffBase {
  masterTariffId: number;
  tariffType: string;
  options: string;
}
